import dashboardMutations from "./mutations.js";
import dashboardActions from "./actions.js";
import dashboardGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
        };
    },
    mutations: dashboardMutations,
    actions: dashboardActions,
    getters: dashboardGetters,
};